<template>
  <div
    v-if="HorizontalBannerData?.length > 0"
    class="horizontal-menu pr0 col-sm-12 pl0 carousel-pr-12"
    :class="[clientPlatform == 'Web' ? 'mb15' : 'mb24']"
  >
    <h3 class="card-catg-name">
      <span>{{ modulePropsData?.title }}</span>
      <button
        class="astext dt-mla-auto normal"
        @click="handleShowMoreClicked($event)"
        v-if="
          clientPlatform == 'Web' &&
          parsedResults?.length >= modulePropsData?.menuItemsToShowUpfront
        "
      >
        {{ showMoreOrLessText }}
      </button>
    </h3>
    <ul class="grid-view">
      <li v-for="(banner, index) in HorizontalBannerData" :key="index">
        <div
          class="d-flex flex-wrap cursor-pointer align-items-center"
          v-on:click="handleMenuCategoryClicked(banner, index)"
          v-if="banner.visible"
        >
          <div class="menu-img-wrap">
            <lazy-image
              class="horizontal-item flex-row img-category-menu"
              :class="[
                modulePropsData?.categoryLogoFrame === 'square'
                  ? 'horizontal-item-square'
                  : 'horizontal-item-circle',
              ]"
              alt="default image"
              :src="getImageUrl(banner)"
            />
          </div>
          <span class="fs-14 color-slaty mt10 tc cat-name">{{
            categoryName(banner)
          }}</span>
        </div>
      </li>
    </ul>
    <button
      class="show-more-btn"
      @click="handleShowMoreClicked($event)"
      v-if="
        parsedResults?.menuHierarchyData?.length >=
        modulePropsData?.menuItemsToShowUpfront
      "
    >
      {{ showMoreOrLessText }}
      <!-- @todo set proper icon -->
      <i class="hkfi-arrow-line" :class="{ 'rotate-90': showMoreEnabled }"></i>
    </button>
    <div class="sub-category-modal-wrap">
      <sub-category-modal></sub-category-modal>
    </div>
  </div>
</template>

<script setup>
import LazyImage from "./LazyImage.vue";
</script>

<script>
import {
  staticImgBaseUrl,
  imgBaseUrl,
  clientPlatform,
  projectBasePathWithFolder,
} from "../config/apiEndpoints";
import Utility from "../helpers/utility";
import {
  keyMapsAction,
  keyMapsGetter,
  keyMapsMutation,
} from "../helpers/storeKeys";
import SubCategoryModal from "../components/SubCategoryModal.vue";
import localStorageFunc from "../helpers/localStorageFunc";
import { EVENT_EXPLORE_MENU_CATEGORY_CLICK } from "../helpers/analyticsEvents";
import { OrderTypesFromCode } from "../helpers/orderTypesConstants";
export default {
  name: "HorizontalBannerWithText",
  components: {
    SubCategoryModal,
  },
  props: { dataResults: {}, moduleProps: {} },
  data() {
    return {
      clientPlatform,
      HorizontalBannerData: [],
      modulePropsData: {},
      staticImgBaseUrl: staticImgBaseUrl,
      imgBaseUrl: imgBaseUrl,
      showMoreEnabled: false,
      showSubCategoryMenu: false,
      parsedResults: [],
      showMoreText: "Show More",
      showLessText: "Show Less",
      hideCategoryIds: [],
    };
  },
  mounted() {
    this.parsedResults = Utility.tryJsonParse(this.dataResults, []);
    this.$store.commit(
      keyMapsMutation.UPDATE_PRODUCT_CATEGORY,
      this.parsedResults?.menuHierarchyData
    );
    this.$store.commit(
      keyMapsMutation.UPDATE_IMG_BASE_URL,
      this.parsedResults?.mediaBaseURL
    );
    this.modulePropsData = Utility.tryJsonParse(this.moduleProps, {
      titleKey: "nodeName",
      thumbnailImageKey: "mediaList[0].mediaUrls.thumbnail",
    });
    this.hideCategoryIds =
      Utility.tryJsonParse(
        this.modulePropsData?.hideCategoryIds?.replace(/'/g, '"'),
        []
      ) || [];
    this.HorizontalBannerData = this.parsedResults?.menuHierarchyData?.slice(
      0,
      this.modulePropsData?.menuItemsToShowUpfront
    );

    if (Array.isArray(this.hideCategoryIds)) {
      this.HorizontalBannerData = this.HorizontalBannerData?.filter(
        (x) =>
          !this.hideCategoryIds.find(
            (y) => y === x.metadataMap.categoryId.values[0]
          )
      );
    }
  },
  methods: {
    handleShowMoreClicked(e) {
      this.showMoreEnabled = !this.showMoreEnabled;
      if (this.showMoreEnabled) {
        this.HorizontalBannerData = this.parsedResults?.menuHierarchyData;
      } else {
        this.HorizontalBannerData =
          this.parsedResults?.menuHierarchyData?.slice(
            0,
            this.modulePropsData?.menuItemsToShowUpfront
          );
      }
      if (Array.isArray(this.hideCategoryIds)) {
        this.HorizontalBannerData = this.HorizontalBannerData?.filter(
          (x) =>
            !this.hideCategoryIds.find(
              (y) => y === x.metadataMap.categoryId.values[0]
            )
        );
      }
    },
    scrollToCategoryId(item, url) {
      if (item) {
        const categoryId =
          item?.metadataMap?.categoryId?.values[0] || "menuTop";
        url = Utility.addUpdateParam(url, "showSearchModal", false);
        return Utility.addUpdateParam(url, "scrollTo", categoryId);
      }
      return url;
    },
    handleMenuCategoryClicked(item, index) {
      if (window.location.href?.includes("/popeyes")) {
        if (this.checkSubCategoryTrigger(item)) {
          this.$store.commit(
            keyMapsMutation.UPDATE_SHOW_SUB_CATEGORY_DATA,
            item?.children?.filter((_) => _.type === "NON_LEAF")
          );
          this.$store.commit(
            keyMapsMutation.UPDATE_SHOW_SUB_CATEGORY_MODAL,
            true
          );
        } else {
          this.scrollto({ nodeId: item?.nodeId });
        }
      } else {
        EVENT_EXPLORE_MENU_CATEGORY_CLICK({
          eventAction: "Go to Coupon Page",
          positionWithinSection: index + 1,
          category: this.categoryName(item),
          subcategory: OrderTypesFromCode[this.currentOrderType],
        });
        this.goto(item); //above code is for home page menu
      }
    },
    getImageUrl(banner) {
      let mediaBaseUrl = this.$store.state.ProductItems.imgBaseUrl;
      return banner?.mediaList?.[0]?.mediaUrls?.thumbnail
        ? mediaBaseUrl + banner?.mediaList?.[0]?.mediaUrls?.thumbnail
        : staticImgBaseUrl + "/images/global/hongs-default-img-lg-grey.jpeg";
    },
    checkSubCategoryTrigger(item) {
      if (
        item?.children?.length > 0 &&
        item?.children?.filter((_) => _.type === "NON_LEAF")?.length
      ) {
        return true;
      }
      return false;
    },
    goto(item) {
      let url =
        projectBasePathWithFolder +
        "/menu/" +
        localStorageFunc.storeId() +
        Utility.getUrlQueryString();
      url = this.scrollToCategoryId(item, url);
      window.location.href = url;
    },
    scrollto({ index, nodeId, categoryName }) {
      Utility.gotoElement({ id: nodeId });
    },
    categoryName(banner) {
      return banner.nodeName?.split("_").join(" ");
    },
  },
  computed: {
    getBottomBarData() {
      return this.$store.state.ProductItems.productItems;
    },
    showMoreOrLessText() {
      return this.showMoreEnabled
        ? this.modulePropsData?.showLessText
        : this.modulePropsData?.showMoreText;
    },
    currentOrderType() {
      return this.$store.state.User.currentOrderType;
    },
  },
};
</script>
